// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Text = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Text.bs.js");
var DOM$SmartcutsMacros = require("../../bs-macros-extension/src/DOM.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var SerialId$SmartcutsMacros = require("../../bs-utils/src/SerialId.bs.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");
var EditGraph$SmartcutsMacros = require("../../bs-edit-graph/src/EditGraph.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../bs-macros-extension/src/DOM__HtmlElement.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("./STEM__Interfaces.bs.js");
var DataExtraction__DataRecord__Types$SmartcutsMacros = require("./DataExtraction__DataRecord__Types.bs.js");
var DataExtraction__DataRecord__Schema__Types$SmartcutsMacros = require("./DataExtraction__DataRecord__Schema__Types.bs.js");

function t_encode(encoder_dataNode, v) {
  return Js_dict.fromArray([
              [
                "friendlyName",
                Decco.optionToJson(Decco.stringToJson, v.friendlyName)
              ],
              [
                "properties",
                Decco.arrayToJson(Curry._1(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.t_encode, encoder_dataNode), v.properties)
              ]
            ]);
}

function t_decode(decoder_dataNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
  if (friendlyName.TAG === /* Ok */0) {
    var properties = Decco.arrayFromJson(Curry._1(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.t_decode, decoder_dataNode), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
    if (properties.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                friendlyName: friendlyName._0,
                properties: properties._0
              }
            };
    }
    var e = properties._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".properties" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = friendlyName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var manyThresholdCount = DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.EdgeCases.AnchorContainingManyProperties.manyThresholdCount;

function isLinkSchemaWithManyProperties(linkSchema) {
  return linkSchema.innerContent.length > manyThresholdCount;
}

function isDataNodeSchemaValueALinkWithManyProperties(dataNodeSchemaValue) {
  if (typeof dataNodeSchemaValue === "number") {
    return dataNodeSchemaValue >= 2;
  } else {
    return false;
  }
}

function areBothEditGraphValuesSatisfyBeingLinksWithManyProperties(schema1, schema2) {
  if (typeof schema1 === "number" && schema1 >= 2 && typeof schema2 === "number") {
    return schema2 >= 2;
  } else {
    return false;
  }
}

function t_encode$1(encoder_dataSchema, v) {
  return Js_dict.fromArray([
              [
                "friendlyName",
                Decco.optionToJson(Decco.stringToJson, v.friendlyName)
              ],
              [
                "properties",
                Decco.arrayToJson(Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_encode, encoder_dataSchema), v.properties)
              ]
            ]);
}

function t_decode$1(decoder_dataSchema, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var friendlyName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "friendlyName"), null));
  if (friendlyName.TAG === /* Ok */0) {
    var properties = Decco.arrayFromJson(Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_decode, decoder_dataSchema), Belt_Option.getWithDefault(Js_dict.get(dict$1, "properties"), null));
    if (properties.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                friendlyName: friendlyName._0,
                properties: properties._0
              }
            };
    }
    var e = properties._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".properties" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = friendlyName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".friendlyName" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function isIdenticalTo(param, param$1) {
  var dataSchema2 = param$1.dataSchema;
  var dataSchema1 = param.dataSchema;
  if (Caml_obj.caml_equal(dataSchema1.htmlTagPathIdentifier, dataSchema2.htmlTagPathIdentifier)) {
    if (areBothEditGraphValuesSatisfyBeingLinksWithManyProperties(dataSchema1.schema, dataSchema2.schema)) {
      return true;
    } else {
      return Curry._4(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.doesContainSameValue, dataSchema1, (function (dataSchema) {
                    return dataSchema.schema;
                  }), (function (dataSchema) {
                    return dataSchema.htmlTagPathIdentifier;
                  }), dataSchema2);
    }
  } else {
    return false;
  }
}

var PropertyEditGraph = EditGraph$SmartcutsMacros.MakeArray({
      isIdenticalTo: isIdenticalTo
    });

function valueFromDataNode(param) {
  return param.value;
}

function makeDataSchema(param, schema) {
  return {
          htmlTagPathIdentifier: param.htmlTagPathIdentifier,
          schema: schema
        };
}

function forDataRecords(dataRecords) {
  var propertySchemas = Belt_Array.reduceWithIndex(dataRecords, [], (function (propertySchemas, dataRecord, dataRecordIndex) {
          var propertySchemasForCurrentDataRecord = Belt_Array.map(dataRecord.properties, Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.fromProperty, valueFromDataNode, makeDataSchema));
          if (propertySchemas.length === 0) {
            return propertySchemasForCurrentDataRecord;
          }
          var editScript = Curry._2(PropertyEditGraph.findShortestEditScript, propertySchemas, propertySchemasForCurrentDataRecord);
          var len = editScript.length;
          if (len !== 1) {
            if (len === 0) {
              return propertySchemas;
            }
            
          } else {
            var match = editScript[0];
            switch (match.TAG | 0) {
              case /* Add */0 :
              case /* Remove */1 :
                  break;
              case /* NoEdit */2 :
                  return propertySchemas;
              
            }
          }
          var nextDataRecord = Belt_Array.get(dataRecords, dataRecordIndex + 1 | 0);
          if (nextDataRecord === undefined) {
            return ArrayUtils$SmartcutsMacros.flatMap(EditGraph$SmartcutsMacros.commandContent, editScript);
          }
          var arg = EditGraph$SmartcutsMacros.findArrangements(editScript);
          var arg$1 = Belt_Array.get((function (param) {
                    return ArrayUtils$SmartcutsMacros.sort(param, arg);
                  })(function (propertySchemas1, propertySchemas2) {
                    var propertySchemasForNextDataRecord = Belt_Array.map(nextDataRecord.properties, Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.fromProperty, valueFromDataNode, makeDataSchema));
                    var editScript1 = Curry._2(PropertyEditGraph.findShortestEditScript, propertySchemas1, propertySchemasForNextDataRecord);
                    var editScript2 = Curry._2(PropertyEditGraph.findShortestEditScript, propertySchemas2, propertySchemasForNextDataRecord);
                    return Caml.caml_int_compare(editScript1.length, editScript2.length);
                  }), 0);
          var param = "Expect to get at least 1 arrangement of propertySchemas";
          return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        }));
  return {
          friendlyName: undefined,
          properties: propertySchemas
        };
}

function dataSchema_encode(v) {
  return Js_dict.fromArray([
              [
                "dataNodeId",
                DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_encode(v.dataNodeId)
              ],
              [
                "htmlTagPathIdentifier",
                STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_encode(v.htmlTagPathIdentifier)
              ],
              [
                "tagPath",
                Decco.arrayToJson(Decco.stringToJson, v.tagPath)
              ],
              [
                "schema",
                Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.value_encode, dataSchema_encode, v.schema)
              ]
            ]);
}

function dataSchema_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var dataNodeId = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNodeId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataNodeId"), null));
  if (dataNodeId.TAG === /* Ok */0) {
    var htmlTagPathIdentifier = STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "htmlTagPathIdentifier"), null));
    if (htmlTagPathIdentifier.TAG === /* Ok */0) {
      var tagPath = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagPath"), null));
      if (tagPath.TAG === /* Ok */0) {
        var schema = Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.value_decode, dataSchema_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "schema"), null));
        if (schema.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    dataNodeId: dataNodeId._0,
                    htmlTagPathIdentifier: htmlTagPathIdentifier._0,
                    tagPath: tagPath._0,
                    schema: schema._0
                  }
                };
        }
        var e = schema._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".schema" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = tagPath._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".tagPath" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = htmlTagPathIdentifier._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".htmlTagPathIdentifier" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = dataNodeId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataNodeId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function propertySchema_encode(v) {
  return Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_encode, dataSchema_encode, v);
}

function propertySchema_decode(v) {
  return Curry._2(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.RecordPropertySchema.t_decode, dataSchema_decode, v);
}

function t_encode$2(v) {
  return t_encode$1(dataSchema_encode, v);
}

function t_decode$2(v) {
  return t_decode$1(dataSchema_decode, v);
}

function valueFromDataSchema(dataSchema) {
  return dataSchema.schema;
}

function fromSchemaWithHtmlTagPathIdentifier(htmlTagPathByHtmlTagPathIdentifier, param) {
  var makeId = SerialId$SmartcutsMacros.makeIdGenerator(undefined);
  var hoistDataSchema = Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.map, (function (param, f) {
          var htmlTagPathIdentifier = param.htmlTagPathIdentifier;
          var arg = Belt_Map.get(htmlTagPathByHtmlTagPathIdentifier, htmlTagPathIdentifier);
          var match = (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              })("Expect to find tagPath by htmlTagPathIdentifier");
          return {
                  dataNodeId: Curry._1(makeId, undefined),
                  htmlTagPathIdentifier: htmlTagPathIdentifier,
                  tagPath: match.tags,
                  schema: Curry._1(f, param.schema)
                };
        }));
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (param) {
                  return {
                          friendlyName: param.friendlyName,
                          dataSchema: Curry._1(hoistDataSchema, param.dataSchema)
                        };
                }))
        };
}

var WithHTPIAndTagPathAndDataNodeId = {
  dataSchema_encode: dataSchema_encode,
  dataSchema_decode: dataSchema_decode,
  propertySchema_encode: propertySchema_encode,
  propertySchema_decode: propertySchema_decode,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  valueFromDataSchema: valueFromDataSchema,
  fromSchemaWithHtmlTagPathIdentifier: fromSchemaWithHtmlTagPathIdentifier
};

function t_encode$3(encoder_htmlElement, encoder_textNode, v) {
  return t_encode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithDomElementOrTextNode.t_encode, encoder_htmlElement, encoder_textNode), v);
}

function t_decode$3(decoder_htmlElement, decoder_textNode, v) {
  return t_decode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithDomElementOrTextNode.t_decode, decoder_htmlElement, decoder_textNode), v);
}

function forHtmlElements(htmlElements) {
  var dataNodesFromChildElements = function (htmlElement) {
    if (htmlElements.indexOf(htmlElement) === -1) {
      return [];
    }
    var childNodes = Array.prototype.slice.call(htmlElement.childNodes);
    if (Belt_Array.some(childNodes, (function (childNode) {
              return Webapi__Dom__Node.nodeType(childNode) === /* Element */0;
            }))) {
      return Belt_Array.concatMany(Belt_Array.map(childNodes, (function (childNode) {
                        var match = Webapi__Dom__Node.nodeType(childNode);
                        if (match >= 3) {
                          return [];
                        }
                        switch (match) {
                          case /* Element */0 :
                              var arg = Curry._1(Webapi__Dom__HtmlElement.ofNode, childNode);
                              return dataNodesForSubtree((function (param) {
                                              return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                            })("Expect htmlElement when nodeType is Element"));
                          case /* Attribute */1 :
                              return [];
                          case /* Text */2 :
                              var arg$1 = Webapi__Dom__Text.ofNode(childNode);
                              var textNode = (function (param) {
                                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                                  })("Expect text node when nodeType is Text");
                              return OptionUtils$SmartcutsMacros.toArray(Belt_Option.flatMap(OptionUtils$SmartcutsMacros.optionalString(textNode.data), (function (textValue) {
                                                if (DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
                                                  return {
                                                          domElementOrTextNode: {
                                                            TAG: /* TextNode */1,
                                                            _0: textNode
                                                          },
                                                          value: {
                                                            TAG: /* PlainText */0,
                                                            _0: textValue
                                                          }
                                                        };
                                                }
                                                
                                              })));
                          
                        }
                      })));
    }
    if (DOM__HtmlElement$SmartcutsMacros.isNotVisibleOnPage(htmlElement)) {
      return [];
    }
    var match = htmlElement.tagName.toLowerCase();
    switch (match) {
      case "img" :
      case "svg" :
          return [];
      default:
        return [{
                  domElementOrTextNode: {
                    TAG: /* HtmlElement */0,
                    _0: htmlElement
                  },
                  value: {
                    TAG: /* PlainText */0,
                    _0: htmlElement.innerText.trim()
                  }
                }];
    }
  };
  var dataNodesForSubtree = function (htmlElement) {
    var match = htmlElement.tagName.toLowerCase();
    switch (match) {
      case "a" :
          if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
            return dataNodesFromChildElements(htmlElement);
          }
          var innerText = htmlElement.innerText.trim();
          var innerContent = dataNodesFromChildElements(htmlElement);
          var url = Belt_Option.map(DOM$SmartcutsMacros.HtmlAnchorElement.ofElement(htmlElement), (function (htmlAnchorElement) {
                  return htmlAnchorElement.href.trim();
                }));
          var maybeHref = url !== undefined && url !== "" ? url : undefined;
          if (Curry._1(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.EdgeCases.AnchorContainingManyProperties.areEnoughChildPropertiesToSurfaceOutOfAnchorNode, innerContent)) {
            return $$Array.append([{
                          domElementOrTextNode: {
                            TAG: /* HtmlElement */0,
                            _0: htmlElement
                          },
                          value: Belt_Option.getWithDefault(Belt_Option.map(maybeHref, (function (url) {
                                      return {
                                              TAG: /* LinkContainingManyProperties */3,
                                              _0: url
                                            };
                                    })), {
                                TAG: /* Button */5,
                                _0: {
                                  maybeHref: undefined,
                                  innerText: innerText,
                                  innerContent: innerContent
                                }
                              })
                        }], innerContent);
          } else {
            return [{
                      domElementOrTextNode: {
                        TAG: /* HtmlElement */0,
                        _0: htmlElement
                      },
                      value: Belt_Option.getWithDefault(Belt_Option.map(maybeHref, (function (url) {
                                  return {
                                          TAG: /* Link */2,
                                          _0: {
                                            url: url,
                                            innerText: innerText,
                                            innerContent: innerContent
                                          }
                                        };
                                })), {
                            TAG: /* Button */5,
                            _0: {
                              maybeHref: undefined,
                              innerText: innerText,
                              innerContent: innerContent
                            }
                          })
                    }];
          }
      case "button" :
          if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
            return dataNodesFromChildElements(htmlElement);
          }
          var innerText$1 = htmlElement.innerText.trim();
          var maybeHref$1 = htmlElement.getAttribute("href");
          return [{
                    domElementOrTextNode: {
                      TAG: /* HtmlElement */0,
                      _0: htmlElement
                    },
                    value: {
                      TAG: /* Button */5,
                      _0: {
                        maybeHref: (maybeHref$1 == null) ? undefined : Caml_option.some(maybeHref$1),
                        innerText: innerText$1,
                        innerContent: dataNodesFromChildElements(htmlElement)
                      }
                    }
                  }];
      case "h1" :
      case "h2" :
      case "h3" :
      case "h4" :
      case "h5" :
      case "h6" :
          break;
      case "img" :
          if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
            return dataNodesFromChildElements(htmlElement);
          }
          var altText = Belt_Option.flatMap(Caml_option.nullable_to_opt(htmlElement.getAttribute("alt")), (function (text) {
                  var altText = text.trim();
                  if (altText === "") {
                    return ;
                  } else {
                    return altText;
                  }
                }));
          var arg = htmlElement.getAttribute("src");
          var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
          var src = (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
              })("Expect to get img.src");
          return [{
                    domElementOrTextNode: {
                      TAG: /* HtmlElement */0,
                      _0: htmlElement
                    },
                    value: {
                      TAG: /* Image */1,
                      _0: {
                        src: src,
                        altText: altText,
                        sources: []
                      }
                    }
                  }];
      case "svg" :
          return [];
      default:
        return dataNodesFromChildElements(htmlElement);
    }
    if (!DOM__HtmlElement$SmartcutsMacros.isVisibleOnPage(htmlElement)) {
      return dataNodesFromChildElements(htmlElement);
    }
    var innerText$2 = htmlElement.innerText.trim();
    return [{
              domElementOrTextNode: {
                TAG: /* HtmlElement */0,
                _0: htmlElement
              },
              value: {
                TAG: /* Headline */4,
                _0: {
                  hLevel: match,
                  innerText: innerText$2,
                  innerContent: dataNodesFromChildElements(htmlElement)
                }
              }
            }];
  };
  var match = Belt_Array.reduce(htmlElements, [
        undefined,
        []
      ], (function (lastResult, htmlElement) {
          var maybeCurrentRootElement = lastResult[0];
          if (maybeCurrentRootElement !== undefined && Caml_option.valFromOption(maybeCurrentRootElement).contains(htmlElement)) {
            return lastResult;
          }
          var dataNodes = dataNodesForSubtree(htmlElement);
          return [
                  Caml_option.some(htmlElement),
                  Belt_Array.concat(lastResult[1], dataNodes)
                ];
        }));
  return {
          friendlyName: undefined,
          properties: Belt_Array.map(match[1], (function (dataNode) {
                  return {
                          friendlyName: undefined,
                          dataNode: dataNode
                        };
                }))
        };
}

function mapHtmlElement(mapHtmlElement$1, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (property) {
                  return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, (function (dataNode) {
                                var func = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.map;
                                return Curry._2(func, (function (param, f) {
                                              return {
                                                      domElementOrTextNode: DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.mapHtmlElement(param.domElementOrTextNode, mapHtmlElement$1),
                                                      value: Curry._1(f, param.value)
                                                    };
                                            }), dataNode);
                              }));
                }))
        };
}

var WithDomElementOrTextNode = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  forHtmlElements: forHtmlElements,
  mapHtmlElement: mapHtmlElement
};

function fromDataRecordWithDomElementOrTextNode(param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (param) {
                  var match = param.dataNode;
                  return {
                          friendlyName: param.friendlyName,
                          dataNode: {
                            domEntities: [match.domElementOrTextNode],
                            value: Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.mapValue, match.value, DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithDomEntities.fromDataNodeWithDomElementOrTextNode)
                          }
                        };
                }))
        };
}

function collapseSiblingPropertiesOfSameTypeAsArray(dataRecord) {
  return {
          friendlyName: dataRecord.friendlyName,
          properties: ArrayUtils$SmartcutsMacros.collapsePairs((function (property1, property2, _remaining) {
                  var match = property1.dataNode;
                  var value1 = match.value;
                  var match$1 = property2.dataNode;
                  var value2 = match$1.value;
                  var domEntities2 = match$1.domEntities;
                  switch (value1.TAG | 0) {
                    case /* PlainText */0 :
                        if (value2.TAG !== /* PlainText */0) {
                          return /* KeepBoth */0;
                        }
                        break;
                    case /* Image */1 :
                        if (value2.TAG !== /* Image */1) {
                          return /* KeepBoth */0;
                        }
                        break;
                    case /* Link */2 :
                        if (value2.TAG !== /* Link */2) {
                          return /* KeepBoth */0;
                        }
                        break;
                    case /* LinkContainingManyProperties */3 :
                        return /* KeepBoth */0;
                    case /* Headline */4 :
                        if (value2.TAG !== /* Headline */4) {
                          return /* KeepBoth */0;
                        }
                        break;
                    case /* Button */5 :
                        if (value2.TAG !== /* Button */5) {
                          return /* KeepBoth */0;
                        }
                        break;
                    case /* Array */6 :
                        switch (value1._0.TAG | 0) {
                          case /* PlainTexts */0 :
                              if (value2.TAG !== /* PlainText */0) {
                                return /* KeepBoth */0;
                              }
                              break;
                          case /* Images */1 :
                              if (value2.TAG !== /* Image */1) {
                                return /* KeepBoth */0;
                              }
                              break;
                          case /* Links */2 :
                              if (value2.TAG !== /* Link */2) {
                                return /* KeepBoth */0;
                              }
                              break;
                          case /* Headlines */3 :
                              if (value2.TAG !== /* Headline */4) {
                                return /* KeepBoth */0;
                              }
                              break;
                          case /* Buttons */4 :
                              if (value2.TAG !== /* Button */5) {
                                return /* KeepBoth */0;
                              }
                              break;
                          case /* Records */5 :
                              return /* KeepBoth */0;
                          
                        }
                        break;
                    
                  }
                  var arg = Belt_Option.map(Belt_Array.get(domEntities2, 0), (function (domElementOrTextNode) {
                          return Belt_Array.some(property1.dataNode.domEntities, (function (param) {
                                        return DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.isSiblingOf(domElementOrTextNode, param);
                                      }));
                        }));
                  if ((function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })(false)) {
                    return {
                            TAG: /* ReplaceWith */0,
                            _0: {
                              friendlyName: property1.friendlyName,
                              dataNode: {
                                domEntities: Belt_Array.concat(match.domEntities, domEntities2),
                                value: Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.combineValues, value1, value2)
                              }
                            }
                          };
                  } else {
                    return /* KeepBoth */0;
                  }
                }), dataRecord.properties)
        };
}

function predicate_arePropertiesStrictlyAdjacentTextNodesAndEmElements(propertiesUnderHtmlParent) {
  var allDomEntitiesUnderParent = Belt_Array.concatMany(Belt_Array.map(propertiesUnderHtmlParent, (function (param) {
              return param.dataNode.domEntities;
            })));
  return Belt_Array.every(allDomEntitiesUnderParent, (function (domEntity) {
                if (DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.isTextNode(domEntity)) {
                  return true;
                } else {
                  return DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.isHtmlElementSatisfying(domEntity, (function (htmlElement) {
                                return htmlElement.tagName === "EM";
                              }));
                }
              }));
}

function replacementPropertiesFactory_forStrictlyAdjacentTextNodesAndEmElements(htmlParentForDomEntities, _properties) {
  return [{
            friendlyName: undefined,
            dataNode: {
              domEntities: [{
                  TAG: /* HtmlElement */0,
                  _0: htmlParentForDomEntities
                }],
              value: {
                TAG: /* PlainText */0,
                _0: htmlParentForDomEntities.innerText.trim()
              }
            }
          }];
}

var defaultStrategiesForTreatingPropertiesWithSharedParentHtmlElement = [[
    predicate_arePropertiesStrictlyAdjacentTextNodesAndEmElements,
    replacementPropertiesFactory_forStrictlyAdjacentTextNodesAndEmElements
  ]];

function determineHowToTreatPropertiesWithSharedParentHtmlElement(htmlParentForDomEntities, propertiesUnderHtmlParent) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.getBy(defaultStrategiesForTreatingPropertiesWithSharedParentHtmlElement, (function (param) {
                        return Curry._1(param[0], propertiesUnderHtmlParent);
                      })), (function (param) {
                    return Curry._2(param[1], htmlParentForDomEntities, propertiesUnderHtmlParent);
                  })), propertiesUnderHtmlParent);
}

function maybeCombinePropertiesThatShareParentHtmlElement(dataRecord) {
  var match = Belt_Array.reduce(dataRecord.properties, [
        [],
        undefined
      ], (function (param, property) {
          var maybeRecordsByCommonParent = param[1];
          var collapsedProperties = param[0];
          var parentHtmlElement = Belt_Option.getExn(DataExtraction__DataRecord__Types$SmartcutsMacros.DomHtmlElementOrTextNode.parentElement(Belt_Array.getExn(property.dataNode.domEntities, 0)));
          if (maybeRecordsByCommonParent === undefined) {
            return [
                    collapsedProperties,
                    [
                      parentHtmlElement,
                      [property]
                    ]
                  ];
          }
          var propertiesUnderHtmlParent = maybeRecordsByCommonParent[1];
          var htmlParentForDomEntities = maybeRecordsByCommonParent[0];
          if (parentHtmlElement === htmlParentForDomEntities) {
            return [
                    collapsedProperties,
                    [
                      parentHtmlElement,
                      $$Array.append(propertiesUnderHtmlParent, [property])
                    ]
                  ];
          } else {
            return [
                    $$Array.append(collapsedProperties, determineHowToTreatPropertiesWithSharedParentHtmlElement(htmlParentForDomEntities, propertiesUnderHtmlParent)),
                    [
                      parentHtmlElement,
                      [property]
                    ]
                  ];
          }
        }));
  var collapsedPropertiesThusFar = match[0];
  var newProperties = Belt_Option.getWithDefault(Belt_Option.map(match[1], (function (param) {
              return $$Array.append(collapsedPropertiesThusFar, determineHowToTreatPropertiesWithSharedParentHtmlElement(param[0], param[1]));
            })), collapsedPropertiesThusFar);
  return {
          friendlyName: dataRecord.friendlyName,
          properties: newProperties
        };
}

var WithDomEntities = {
  fromDataRecordWithDomElementOrTextNode: fromDataRecordWithDomElementOrTextNode,
  collapseSiblingPropertiesOfSameTypeAsArray: collapseSiblingPropertiesOfSameTypeAsArray,
  maybeCombinePropertiesThatShareParentHtmlElement: maybeCombinePropertiesThatShareParentHtmlElement
};

function fromWithDomEntities(lookupTable, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (property) {
                  var func = DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPI.fromDataNodeWithDomEntities;
                  return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, (function (param) {
                                return Curry._2(func, param, lookupTable);
                              }));
                }))
        };
}

function mapHtmlTagPathIdentifier(mapHtmlTagPathIdentifier$1, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (property) {
                  return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, (function (dataNode) {
                                return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPI.mapHtmlTagPathIdentifier, dataNode, mapHtmlTagPathIdentifier$1);
                              }));
                }))
        };
}

var WithHtmlElementAndHTPI = {
  fromWithDomEntities: fromWithDomEntities,
  mapHtmlTagPathIdentifier: mapHtmlTagPathIdentifier
};

function t_encode$4(encoder_htmlElement, encoder_textNode, v) {
  return t_encode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode, encoder_htmlElement, encoder_textNode), v);
}

function t_decode$4(decoder_htmlElement, decoder_textNode, v) {
  return t_decode(Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode, decoder_htmlElement, decoder_textNode), v);
}

function makeDataNode(param, param$1) {
  var hoistValue = function (schema, value) {
    if (typeof schema === "number") {
      switch (schema) {
        case /* PlainText */0 :
            if (value.TAG === /* PlainText */0) {
              return {
                      TAG: /* PlainText */0,
                      _0: value._0
                    };
            }
            break;
        case /* Image */1 :
            if (value.TAG === /* Image */1) {
              return {
                      TAG: /* Image */1,
                      _0: value._0
                    };
            }
            break;
        case /* LinkContainingManyProperties */2 :
            if (value.TAG === /* LinkContainingManyProperties */3) {
              return {
                      TAG: /* LinkContainingManyProperties */3,
                      _0: value._0
                    };
            }
            break;
        
      }
    } else {
      switch (schema.TAG | 0) {
        case /* Link */0 :
            if (value.TAG === /* Link */2) {
              var linkNode = value._0;
              return {
                      TAG: /* Link */2,
                      _0: {
                        url: linkNode.url,
                        innerText: linkNode.innerText,
                        innerContent: Belt_Array.map(Belt_Array.zip(schema._0.innerContent, linkNode.innerContent), (function (param) {
                                return makeDataNode(param[0], param[1]);
                              }))
                      }
                    };
            }
            break;
        case /* Headline */1 :
            if (value.TAG === /* Headline */4) {
              var headlineNode = value._0;
              return {
                      TAG: /* Headline */4,
                      _0: {
                        hLevel: headlineNode.hLevel,
                        innerText: headlineNode.innerText,
                        innerContent: Belt_Array.map(Belt_Array.zip(schema._0.innerContent, headlineNode.innerContent), (function (param) {
                                return makeDataNode(param[0], param[1]);
                              }))
                      }
                    };
            }
            break;
        case /* Button */2 :
            if (value.TAG === /* Button */5) {
              var buttonNode = value._0;
              return {
                      TAG: /* Button */5,
                      _0: {
                        maybeHref: buttonNode.maybeHref,
                        innerText: buttonNode.innerText,
                        innerContent: Belt_Array.map(Belt_Array.zip(schema._0.innerContent, buttonNode.innerContent), (function (param) {
                                return makeDataNode(param[0], param[1]);
                              }))
                      }
                    };
            }
            break;
        case /* Array */3 :
            var match = schema._0;
            if (typeof match === "number") {
              if (match === /* PlainTexts */0) {
                if (value.TAG === /* Array */6) {
                  var texts = value._0;
                  if (texts.TAG === /* PlainTexts */0) {
                    return {
                            TAG: /* Array */6,
                            _0: {
                              TAG: /* PlainTexts */0,
                              _0: texts._0
                            }
                          };
                  }
                  
                }
                
              } else if (value.TAG === /* Array */6) {
                var images = value._0;
                if (images.TAG === /* Images */1) {
                  return {
                          TAG: /* Array */6,
                          _0: {
                            TAG: /* Images */1,
                            _0: images._0
                          }
                        };
                }
                
              }
              
            } else {
              switch (match.TAG | 0) {
                case /* Links */0 :
                    var innerSchema = match._0.innerContent;
                    if (value.TAG === /* Array */6) {
                      var linkNodes = value._0;
                      if (linkNodes.TAG === /* Links */2) {
                        return {
                                TAG: /* Array */6,
                                _0: {
                                  TAG: /* Links */2,
                                  _0: Belt_Array.map(linkNodes._0, (function (linkNode) {
                                          return {
                                                  url: linkNode.url,
                                                  innerText: linkNode.innerText,
                                                  innerContent: Belt_Array.map(Belt_Array.zip(innerSchema, linkNode.innerContent), (function (param) {
                                                          return makeDataNode(param[0], param[1]);
                                                        }))
                                                };
                                        }))
                                }
                              };
                      }
                      
                    }
                    break;
                case /* Headlines */1 :
                    var innerSchema$1 = match._0.innerContent;
                    if (value.TAG === /* Array */6) {
                      var headlineNodes = value._0;
                      if (headlineNodes.TAG === /* Headlines */3) {
                        return {
                                TAG: /* Array */6,
                                _0: {
                                  TAG: /* Headlines */3,
                                  _0: Belt_Array.map(headlineNodes._0, (function (headlineNode) {
                                          return {
                                                  hLevel: headlineNode.hLevel,
                                                  innerText: headlineNode.innerText,
                                                  innerContent: Belt_Array.map(Belt_Array.zip(innerSchema$1, headlineNode.innerContent), (function (param) {
                                                          return makeDataNode(param[0], param[1]);
                                                        }))
                                                };
                                        }))
                                }
                              };
                      }
                      
                    }
                    break;
                case /* Buttons */2 :
                    var innerSchema$2 = match._0.innerContent;
                    if (value.TAG === /* Array */6) {
                      var buttonNodes = value._0;
                      if (buttonNodes.TAG === /* Buttons */4) {
                        return {
                                TAG: /* Array */6,
                                _0: {
                                  TAG: /* Buttons */4,
                                  _0: Belt_Array.map(buttonNodes._0, (function (buttonNode) {
                                          return {
                                                  maybeHref: buttonNode.maybeHref,
                                                  innerText: buttonNode.innerText,
                                                  innerContent: Belt_Array.map(Belt_Array.zip(innerSchema$2, buttonNode.innerContent), (function (param) {
                                                          return makeDataNode(param[0], param[1]);
                                                        }))
                                                };
                                        }))
                                }
                              };
                      }
                      
                    }
                    break;
                case /* Records */3 :
                    var propertySchemas = match._0.properties;
                    if (value.TAG === /* Array */6) {
                      var records = value._0;
                      if (records.TAG === /* Records */5) {
                        return {
                                TAG: /* Array */6,
                                _0: {
                                  TAG: /* Records */5,
                                  _0: Belt_Array.map(records._0, (function (record) {
                                          return {
                                                  friendlyName: record.friendlyName,
                                                  properties: Belt_Array.map(Belt_Array.zip(propertySchemas, record.properties), (function (param) {
                                                          var property = param[1];
                                                          return {
                                                                  friendlyName: property.friendlyName,
                                                                  dataNode: makeDataNode(param[0].dataSchema, property.dataNode)
                                                                };
                                                        }))
                                                };
                                        }))
                                }
                              };
                      }
                      
                    }
                    break;
                
              }
            }
            break;
        
      }
    }
    console.warn("schema", schema);
    console.warn("value", value);
    return Util$SmartcutsMacros.logAndRaiseJsError("Expect matching schema and value");
  };
  return {
          dataNodeId: param.dataNodeId,
          htmlTagPathIdentifier: param.htmlTagPathIdentifier,
          domEntities: param$1.domEntities,
          tagPath: param.tagPath,
          value: hoistValue(param.schema, param$1.value)
        };
}

function fromDataRecordWithHtmlElementAndHTPI(schema, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.reduce(param.properties, [
                  schema.properties,
                  []
                ], (function (param, param$1) {
                    var dataNode = param$1.dataNode;
                    var properties = param[1];
                    var propertySchemas = param[0];
                    var match = ArrayUtils$SmartcutsMacros.firstMatchi((function (param) {
                            var dataSchema = param.dataSchema;
                            if (Caml_obj.caml_equal(dataSchema.htmlTagPathIdentifier, dataNode.htmlTagPathIdentifier)) {
                              if (isDataNodeSchemaValueALinkWithManyProperties(dataSchema.schema)) {
                                return true;
                              } else {
                                return Curry._6(DataExtraction__DataRecord__Schema__Types$SmartcutsMacros.DataNodeSchema.doesMatchDataNode, dataSchema, valueFromDataSchema, (function (dataNode) {
                                              return dataNode.value;
                                            }), undefined, undefined, dataNode);
                              }
                            } else {
                              return false;
                            }
                          }), propertySchemas);
                    if (match === undefined) {
                      return [
                              propertySchemas,
                              properties
                            ];
                    }
                    var property_friendlyName = param$1.friendlyName;
                    var property_dataNode = makeDataNode(match[0].dataSchema, dataNode);
                    var property = {
                      friendlyName: property_friendlyName,
                      dataNode: property_dataNode
                    };
                    return [
                            Belt_Array.sliceToEnd(propertySchemas, match[1] + 1 | 0),
                            Belt_Array.concat(properties, [property])
                          ];
                  }))[1]
        };
}

function getDataNodesById(dataNodeId, param) {
  return Belt_Array.keep(ArrayUtils$SmartcutsMacros.flatMap((function (param) {
                    return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.allNodes, param.dataNode, (function (param) {
                                  return param.value;
                                }));
                  }), param.properties), (function (dataNode) {
                return dataNode.dataNodeId === dataNodeId;
              }));
}

function mapHtmlElement$1(mapHtmlElement$2, param) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (property) {
                  return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, (function (dataNode) {
                                return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.mapHtmlElement, dataNode, mapHtmlElement$2);
                              }));
                }))
        };
}

function mapTextNode(param, f) {
  return {
          friendlyName: param.friendlyName,
          properties: Belt_Array.map(param.properties, (function (property) {
                  return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.RecordProperty.mapDataNode, property, (function (dataNode) {
                                return Curry._2(DataExtraction__DataRecord__Types$SmartcutsMacros.DataNode.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.mapTextNode, dataNode, f);
                              }));
                }))
        };
}

var WithHtmlElementAndHTPIAndTagPathAndDataNodeId = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  makeDataNode: makeDataNode,
  fromDataRecordWithHtmlElementAndHTPI: fromDataRecordWithHtmlElementAndHTPI,
  getDataNodesById: getDataNodesById,
  mapHtmlElement: mapHtmlElement$1,
  mapTextNode: mapTextNode
};

var EdgeCases2 = {
  AnchorContainingManyProperties: {
    isLinkSchemaWithManyProperties: isLinkSchemaWithManyProperties,
    areBothEditGraphValuesSatisfyBeingLinksWithManyProperties: areBothEditGraphValuesSatisfyBeingLinksWithManyProperties
  }
};

var Schema_WithHtmlTagPathIdentifier = {
  valueFromDataNode: valueFromDataNode,
  makeDataSchema: makeDataSchema,
  forDataRecords: forDataRecords
};

var Schema = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  WithHtmlTagPathIdentifier: Schema_WithHtmlTagPathIdentifier,
  WithHTPIAndTagPathAndDataNodeId: WithHTPIAndTagPathAndDataNodeId
};

exports.EdgeCases2 = EdgeCases2;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.Schema = Schema;
exports.WithDomElementOrTextNode = WithDomElementOrTextNode;
exports.WithDomEntities = WithDomEntities;
exports.WithHtmlElementAndHTPI = WithHtmlElementAndHTPI;
exports.WithHtmlElementAndHTPIAndTagPathAndDataNodeId = WithHtmlElementAndHTPIAndTagPathAndDataNodeId;
/* PropertyEditGraph Not a pure module */
